import axios from "../../utils/axios";

export const getTransactions = async ({ isLimit, type, search, pageNo }) => {
  let queryString = "";
  if (isLimit) {
    queryString += `&_limit=${isLimit}`;
  }
  if (type) {
    queryString += `&type_like=${type}`;
  }
  if (search) {
    queryString += `&name_like=${search}`;
  }

  if (pageNo) {
    queryString += `&_page=${pageNo}`;
  }
  const response = await axios.get(
    `/transactions?_sort=id&_order=desc${queryString}`
  );

  return {
    transactions: response.data,
    total_count: response.headers["x-total-count"],
  };
};

export const getBalance = async () => {
  const response = await axios.get("/transactions");
  let income = 0;
  response?.data?.forEach((transaction) => {
    const { type, amount } = transaction;
    if (type === "income") {
      income += amount;
    } else {
      income -= amount;
    }
  });
  return income;
};

export const addTransaction = async (data) => {
  const response = await axios.post("/transactions", data);
  const getLandingResponse = await axios.get(
    "/transactions?_sort=id&_order=desc&_limit=5"
  );

  return {
    create: response.data || {},
    landingData: getLandingResponse?.data || {},
  };
};

export const editTransaction = async (id, data) => {
  const response = await axios.put(`/transactions/${id}`, data);

  return response.data;
};

export const deleteTransaction = async (id) => {
  const response = axios.delete(`/transactions/${id}`);
  const getLandingResponse = await axios.get(
    "/transactions?_sort=id&_order=desc&_limit=6"
  );
  const modifyRemove = getLandingResponse?.data.filter(
    (data) => data.id !== id
  );

  return {
    delete: response.data || {},
    landingData: modifyRemove || {},
    total_count: modifyRemove?.length + "",
  };
};
